import { render, staticRenderFns } from "./LandingImage.vue?vue&type=template&id=283ff714&scoped=true"
import script from "./LandingImage.vue?vue&type=script&lang=js"
export * from "./LandingImage.vue?vue&type=script&lang=js"
import style0 from "./LandingImage.vue?vue&type=style&index=0&id=283ff714&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283ff714",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('283ff714')) {
      api.createRecord('283ff714', component.options)
    } else {
      api.reload('283ff714', component.options)
    }
    module.hot.accept("./LandingImage.vue?vue&type=template&id=283ff714&scoped=true", function () {
      api.rerender('283ff714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Landing/components/LandingImage.vue"
export default component.exports